import * as React from 'react';
import { AutoCompleteProps } from 'antd/lib/auto-complete';
import { GraphqlQuery } from 'requestapijs';
import { Spin, AutoComplete } from 'antd';
import { StateNodeConnection, StateNodeEdge } from '../../../schema';
import { OptionProps } from 'antd/lib/select';

interface CustomOption extends OptionProps {
  label?: React.ReactNode;
  display?: string;
  state?: any;
}

const Option = AutoComplete.Option as React.ClassicComponentClass<CustomOption>;

interface StateDropDownProps extends AutoCompleteProps {
  extrafields?: string[];
}

export class StateDropdown extends React.Component<StateDropDownProps, State> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props: Readonly<StateDropDownProps>) {
    super(props);

    this.state = {
      name: '',
      state: null,
      touched: false,
    };
  }

  value = (states: StateNodeEdge[]) => {
    if (this.state.touched) {
      return this.state.name;
    }

    const state = states.find((v) => v.node?.id === this.props.value);
    if (!state) return;
    return state.node?.name;
  };

  render() {
    const { name } = this.state;
    const { extrafields, value, onSelect } = this.props;
    return (
      <GraphqlQuery
        queryString={`query StateDropDown($id: ID, $name: String, ) {
          allStates(id: $id, name_Icontains: $name) {
            edges {
              node {
                id
                name
              }
            }
          }
        }`}
        variables={{
          after: '',
          name,
          id: value && !name ? value : '',
        }}
        render={(
          response: { allStates: StateNodeConnection },
          error,
          loading,
        ) => {
          if (loading) {
            return <Spin />;
          }
          if (error) {
            return <div>{JSON.stringify(error)}</div>;
          }
          if (response) {
            return (
              <div style={{ margin: '5px 0' }}>
                <AutoComplete
                  {...this.props}
                  placeholder="Select State"
                  dataSource={response.allStates.edges.map((state) => (
                    <Option
                      key={state.node?.id}
                      label={state.node}
                      state={state}
                    >
                      {state.node?.name}
                    </Option>
                  ))}
                  value={this.value(response.allStates.edges)}
                  optionLabelProp="children"
                  style={{ width: '100%' }}
                  onSearch={(state) =>
                    this.setState({ name: state, touched: true })
                  }
                  onSelect={(e, f) => {
                    this.setState({
                      name: (f as any).props.state.node.name,
                      touched: true,
                    });
                    onSelect && onSelect(e, f);
                  }}
                />
              </div>
            );
          }
        }}
      />
    );
  }
}

interface State {
  name: string;
  state: StateNodeEdge | null;
  touched: boolean;
}
